// Necessary for typing in actions and getters.
/* eslint-disable @typescript-eslint/no-use-before-define, no-use-before-define */

import { emptyValues } from '@/constants';
import { Client } from '@/types/app';
import { defineModule, localActionContext, localGetterContext } from 'direct-vuex';
import { ActionContext } from 'vuex';
import { GeoPoint } from '@firebase/firestore-types';

export interface InternalState {
  isLoading: boolean;
  linkedClientSelect: Client;
  jobName: string;
  linkedLocation: GeoPoint;
}

export const internalModule = defineModule({
  namespaced: true,
  state: (): InternalState => ({
    isLoading: false,
    linkedClientSelect: emptyValues.client,
    jobName: '',
    linkedLocation: emptyValues.geoPoint
  }),
  getters: {
    get: (...args) => (key: keyof InternalState): InternalState[keyof InternalState] => {
      const { state } = getterContext(args);

      return state[key];
    }
  },
  mutations: {
    set: <PropName extends keyof InternalState, PropType extends InternalState[PropName]>(
      state: InternalState,
      [key, value]: [PropName, PropType]
    ) => {
      state[key] = value;
    }
  },
  actions: {
    update: <PropName extends keyof InternalState, PropType extends InternalState[PropName]>(
      context: ActionContext<unknown, unknown>,
      payload: [PropName, PropType]
    ) => {
      const { commit } = actionContext(context);
      commit.set(payload);
    }
  }
});

const getterContext = (args: [unknown, unknown, unknown, unknown]) => localGetterContext(args, internalModule);
const actionContext = (context: ActionContext<unknown, unknown>) => localActionContext(context, internalModule);
